import { ethers } from 'ethers'
import { CHAIN } from 'config'
import useToast from 'hooks/useToast';
import { getMarketplaceContract, getNFTContract, getRewardContract } from '../contractHelpers'

async function getTransactionLogs(_provider: any, _txHash: any) {
  const txReceipt = await _provider.getTransactionReceipt(_txHash);
  return txReceipt.logs;
}

export const callMintNFT = async (web3Context: any, collection: string, jsonHash: string, content: string, price: number, toastSuccess: any, toastError: any) => {
  if(!web3Context?.provider || !web3Context?.account) {
    toastError("Confirm your wallet connection.")
    return {success: false, nftId: undefined}
  }
  if(web3Context?.chainId !== CHAIN) {
    toastError("Confirm You are in Goerli Network.")
    return {success: false, nftId: undefined}
  }
  try {
    const contract = getMarketplaceContract(web3Context.provider)
    const tx = await contract.methods
      .createItems(collection, jsonHash, content, ethers.utils.parseEther(price.toString()))
      .send({ from: web3Context.account })
    toastSuccess("Transaction Success!")
    return {success: true, nftId: tx.events.CreateItem.returnValues[1]}
  } catch (error) {
    console.error(error)
    toastError("Something went wrong.")
    return {success: false, nftId: undefined}
  }
}

export const callCreateCollection = async (web3Context: any, name: string, symbol: string, content: string, toastSuccess: any, toastError: any) => {
  if(!web3Context?.provider || !web3Context?.account) {
    toastError("Confirm your wallet connection.")
    return {success: false, collection: undefined}
  }
  if(web3Context?.chainId !== CHAIN) {
    toastError("Make sure you are connected to Butane Network.")
    return {success: false, collection: undefined}
  }
  try {
    // console.log("aria marketplace = ", web3Context)
    const contract = getMarketplaceContract(web3Context.provider)
    console.log("aria contract = ", ethers.constants.MaxUint256)
    console.log("aria content = ", content)
    const tx = await contract.methods
      .createCollection(name, symbol, ethers.constants.MaxUint256, content)
      .send({ from: web3Context.account })
    toastSuccess("Transaction Success!")
    return {success: true, collection: tx.events.CreateCollection.returnValues[0]}
  } catch (error) {
    console.error(error)
    toastError("Something went wrong.")
    return {success: false, collection: undefined}
  }
}

export const callApproveForAll = async (provider: any, address: string, approveAddress:string, approved: boolean) => {
    const nftContract = getNFTContract(provider)
    return await nftContract.methods
      .setApprovalForAll(approveAddress, approved)
      .send({ from: address })
}

export const callApproveForErc20 = async (provider: any, address: string, approveAddress:string) => {
  const rewardContract = getRewardContract(provider)
  return await rewardContract.methods
    .approve(approveAddress, ethers.constants.MaxUint256)
    .send({ from: address })
}